<template>
  <div class="p-personNewsFeed">
    <div class="p-personNewsFeed-tab">
      <a :href="newGraduatePath" class="p-personNewsFeed-tab-item new_graduate" :class="{ isActive: currentTab.isNewGraduate }">新卒(就活)</a>
      <a :href="careerPath" class="p-personNewsFeed-tab-item career" :class="{ isActive: currentTab.isCareer }">中途(転職)</a>
      <a :href="favoritePath" class="p-personNewsFeed-tab-item favorite" :class="{ isActive: currentTab.isFavorite }"><i class="u-icon-heart"></i>お気に入り</a>
    </div>

    <div class="p-personNewsFeed-body hoge" :class="currentTab.name" ref="item">
      <div class="p-personNewsFeed-searchInput">
        <i class="u-icon-status-search"></i>
        <input type="text" name="searchInput" placeholder="キーワードで絞り込み" v-model="searchString">
      </div>

      <p class="fw-b ta-c mt20" v-show="showEmptyMessage">キーワードに一致する記事がありません</p>
      <p class="fw-b ta-c mt20" v-show="currentTab.isFavorite && Object.keys(sortedFeedData).length === 0">お気に入り記事はありません</p>

      <div class="p-personNewsFeed-dateGroup mt20" v-for="(date, index) in sortedDates" :key="index">
        <div class="p-personNewsFeed-dateGroup-label"><span class="ff-damion">News Feed</span></div>
        <p class="fw-b ta-c fz115 lh100 mt10">{{ formatDate(date) }}</p>
        <div class="p-personNewsFeed-article mt20" v-for="article in sortedFeedData[date]" :key="article.id" :data-keywords="article.keywords">
          <a :href="article.url" class="hov" target="_blank" rel="noopener noreferrer">
            <img :src="article['og:image']" alt="og:image" loading="lazy" @error="onImgError">
            <div class="p-personNewsFeed-article-info">
              <p class="fw-b lh130">{{ article['og:title'] }}</p>
              <p class="fw-b fz90 mt5" style="color: #8B8B8B;"><i class="u-icon-link mr5"></i>{{ urlDomain(article.url) }}</p>
            </div>
          </a>
          <button type="button" class="p-personNewsFeed-article-favoriteButton hov">
            <label>
              <input type="checkbox" :name="article.id" @change="onFavoriteButtonChange(article.id, $event)" :checked="isFavorite(article.id)">
              <i class="u-icon-heart"></i>
            </label>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
function debounce(func, waitms) {
  let timeoutID;
  return function(...args) {
    const ctx = this;
    if (timeoutID) clearTimeout(timeoutID);
    timeoutID = setTimeout(() => {
      func.apply(ctx, args)
    }, waitms);
  }
}

export default {
  props: {
    newGraduatePath: { type: String, required: true },
    careerPath: { type: String, required: true },
    favoritePath: { type: String, required: true },
    feedData: { type: Object, required: true },
    favoriteArticleIds: { type: Array, required: true, default: () => [] },
    articleLength: { type: Number, require: true },
  },
  data() {
    return {
      currentTab: {
        name: this.lastPathSegment(location.pathname),
        isNewGraduate: this.lastPathSegment(location.pathname) === 'new_graduate',
        isCareer: this.lastPathSegment(location.pathname) === 'career',
        isFavorite: this.lastPathSegment(location.pathname) === 'favorite',
      },
      sortedDates: [],
      sortedFeedData: {},
      searchString: '',
      searchTimeoutId: null,
      showEmptyMessage: false,
    }
  },
  created() {
    this.sortedFeedData = this.feedData;
    this.sortedDates = Object.keys(this.feedData).sort().reverse();
    this.searchArticle = debounce(this.filterArticle, 300);
  },
  watch: {
    searchString(newQuery) {
      const words = newQuery.trim().split(' ');
      this.searchArticle(words);
    }
  },
  methods: {
    lastPathSegment(pathstr) {
      return pathstr.split('/').filter((str) => str && str.trim()).at(-1);
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const weekDays = ['日', '月', '火', '水', '木', '金', '土'];
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const weekDay = weekDays[date.getDay()];

      return `${year}年${month}月${day}日(${weekDay})`;
    },
    urlDomain(urlString) {
      try {
        const url = new URL(urlString);
        return url.hostname;
      } catch (e) {
        return null;
      }
    },
    onImgError(e) {
      e.currentTarget.style.display = 'none';
    },
    async onFavoriteButtonChange(id, e) {
      const target = e.currentTarget;

      const res = fetch('/person/my_page/news/favorite', {
        method: target.checked ? 'POST' : 'DELETE',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id }),
      });
    },
    filterArticle(words) {
      const articleElements = document.querySelectorAll('[data-keywords]');
      articleElements.forEach((elem) => elem.hidden = false);
      const dateGroups = document.querySelectorAll('.p-personNewsFeed-dateGroup');
      dateGroups.forEach((elem) => elem.hidden = false);

      words = words.filter((word) => !!word).map((word) => `:not([data-keywords*="${word}"])`);
      if (words.length > 0) {
        const queryString = `.p-personNewsFeed-article${words.join('')}`;
        const hideElements = document.querySelectorAll(queryString);
        hideElements.forEach((elem) => elem.hidden = true);

        dateGroups.forEach((group) => {
          const articles = group.querySelectorAll('.p-personNewsFeed-article');
          const hidArticles = group.querySelectorAll('.p-personNewsFeed-article[hidden]');
          if (articles.length === hidArticles.length)  {
            group.hidden = true;
          }
        });
      }

      const hidArticles = document.querySelectorAll('.p-personNewsFeed-article[hidden]');
      this.showEmptyMessage = this.articleLength === hidArticles.length;
    },
    isFavorite(articleId) {
      const id = parseInt(articleId, 10);
      return this.favoriteArticleIds.includes(id);
    },
  }
}
</script>

<style scoped>
.rotate {
  animation: spin 3s linear infinite;
}
@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}
</style>
